import React from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useAuth } from "../../../AuthProvider";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { accounts, inProgress } = useMsal();
  const { isAuthenticated } = useAuth();

  // Show loading state while authentication is being checked
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-primary-navy-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
        <h2 className="text-xl font-semibold text-white">
          Authentication in progress...
        </h2>
        <p className="text-gray-300 mt-2">
          Please wait while we verify your credentials.
        </p>
      </div>
    );
  }

  // If no user is signed in or not authenticated, redirect to login page
  if (accounts.length === 0 || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render children
  return <>{children}</>;
};

export default ProtectedRoute;
